import React from "react";
import autoBind from "react-autobind";
import { Layout, Form, Row, Col, Select, Button, Input } from "antd";
import PageHeader from '@/components/PageHeader/PageHeader';
import moment from "moment";
//
import CustomComponent from "@/components/CustomComponent";
import WhiteBox from "@/views/commonComponents/WhiteBox";
import CommonLoadingView from "@/views/commonComponents/CommonLoadingView";
import config from "@/config/config";
import Utils from "@/components/Utils";
import Globals from "@/config/Globals";
//
export default class AdminMembersDuesPostingByTypeReportView extends CustomComponent {
  constructor(props) {
    super(props);
    autoBind(this);

    this.state = {
      isLoading: false,
    };
  }

  componentDidMount() {
    document.title = `${config.ApplicationName} - Dues Posting By Type`;
  }

  async handleSubmit() {
    const formData = await this.form.validateFields();

    if (formData) {
      this._generate(formData);
    }
  }

  render() {
    return (
      <Layout.Content className="pageContent">
        <CommonLoadingView isLoading={this.state.isLoading} isFixed />
        <PageHeader
          title="Dues Posting By Type"
          extra={[
            <Button key="1" onClick={this.handleSubmit} type="primary">
              Generate Report
            </Button>,
          ]}
        />
        <Layout.Content>
          <WhiteBox>
            <Form layout="vertical" {...Utils.propagateRef(this, "form")}>
              <Row>
                <Col span={4}>
                  <Form.Item
                    name="year"
                    label="Year"
                    rules={[
                      { required: true, message: "This field is required." },
                      { pattern: /^\d{4}$/, message: "Year must be in YYYY format." },
                    ]}
                  >
                    <Input placeholder="YYYY" maxLength={4} />
                  </Form.Item>
                </Col>
                <Col span={6} offset={1}>
                  <Form.Item name="type" label="Type" rules={[{ required: true, message: "This field is required." }]}>
                    <Select placeholder="Select...">
                      <Select.Option value="ALL">All Members</Select.Option>
                      <Select.Option value="CASH">Members with only Cash dues</Select.Option>
                      <Select.Option value="EMPLOYER">Members with only Employer dues</Select.Option>
                      <Select.Option value="BOTH">Members with Both Cash AND Employer dues</Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </WhiteBox>
        </Layout.Content>
      </Layout.Content>
    );
  }

  /* private API */
  async _generate(data) {
    this.startLoading();
    //request
    const resp = await this.props.app.api.reports.duesPostingByType(data);
    if (!this._isMounted) return;
    if (resp.statusCode == 200 && resp.body) {
      Utils.downloadBlob(resp.body, `dues-posting-by-type-${data.year}-${moment(new Date()).format(Globals.DefaultSimpleDateFormat)}`, "xlsx");
    } else {
      this.props.app.alertController.showAPIErrorAlert(null, resp);
    }
    this.setState({ isLoading: false });
  }
}
